import React, { useEffect, useState } from "react";
import { Configration, useUser } from "../components/UserContext";
import { GetConfigurationPageSetup, patchConfigurationPageSetup, postConfigurationPageSetup } from "src/shared/services/services";
import { errorHandling } from "src/shared/utils/errorHandling";
import { closeLoading, notifyLoading } from "src/assets/toastService";

export const defaultData: Configration = {
  printType: "print:1",
  tableDefaultSize: 10,
  copyQty: 1,
  billResetPeriod: "noreset",
  billNoEnabled: false,
  foodTypes: ["Veg", "Non-Veg"],
  contactQrCode: "",
  locationQrCode: "",
  termsAndConditionsEnglish: "",
  termsAndConditionsArabic: "",
  enableTermsAndConditions: false,
  isDefaultTabsEnabled: false,
  isProductsNotesEnabled: false,
  deliveryFeeEnabled: false,
  parcelFeeEnabled: false,
  tipsEnabled: false,
  printProductLimit: "100",
  customBusinessName: "Grocery",
  orderTableType: "Table Type:1",
  contact_qr_codeAWS: "",
  location_qr_codeAWS: "",
  appPrinterEnabled: false,
  orderIdEnabled: true,
  customEnabled: false,
  layoutId: "",
  cardPayment: false,
}

function useConfigration() {
  const { setConfigurations } = useUser();
  const [config, setConfig] = useState<Configration>();

  const getConfig = () => {
    GetConfigurationPageSetup()
      ?.then((res) => {
        const data = res?.data.result[0];
        if (!data) {
          setConfig(defaultData);
          setConfigurations(defaultData);
          return
        }
        setConfig(data);
        setConfigurations(data);
      })
      .catch((error) => errorHandling(error));
  };
  useEffect(() => {
    getConfig();
  }, []);

  const postConfig = (updates: any) => {
    notifyLoading("please wait POS configration updated");
    try {
      postConfigurationPageSetup(updates);
      closeLoading();
      setTimeout(() => {
        // notifySuccess("Configration Updated Sucessfully");
        getConfig();
      }, 2000);
    } catch (error) {
      errorHandling(error);
    }
  };

  const patchConfig = (updates: any) => {
    notifyLoading("please wait POS configration updated");
    try {
      patchConfigurationPageSetup(updates);
      closeLoading();
      setTimeout(() => {
        // notifySuccess("Configration Updated Sucessfully");
        getConfig();
      }, 2000);
    } catch (error) {
      errorHandling(error);
    }
  };

  return { config, postConfig, patchConfig };
}

export default useConfigration;
